export const UPDATE_WHATSAPP_CHARGES_REQUEST = "UPDATE_WHATSAPP_CHARGES_REQUEST";
export const UPDATE_WHATSAPP_CHARGES_SUCCESS = "UPDATE_WHATSAPP_CHARGES_SUCCESS";
export const UPDATE_WHATSAPP_CHARGES_FAILURE = "UPDATE_WHATSAPP_CHARGES_FAILURE";
export const UPDATE_WHATSAPP_CHARGES_RESET = "UPDATE_WHATSAPP_CHARGES_RESET";
export const updateWhatsappChargesRequest = (payload) => ({
    type: UPDATE_WHATSAPP_CHARGES_REQUEST,
    payload,
});
export const updateWhatsappChargesSuccess = (payload) => ({
    type: UPDATE_WHATSAPP_CHARGES_SUCCESS,
    payload,
});
export const updateWhatsappChargesFailure = (payload) => ({
    type: UPDATE_WHATSAPP_CHARGES_FAILURE,
    payload,
});
export const updateWhatsappChargesReset = () => ({
    type: UPDATE_WHATSAPP_CHARGES_RESET,
});
